import { createSlice } from "@reduxjs/toolkit";
import * as Actions from "../actions";
import { dataBarrarEntregaReducer } from "../reducers";
import { InitialStateBarrarEntrega } from "../models/barrarEntrega.model";

const initialState: InitialStateBarrarEntrega = {
  items: [],
  dialogForm: {
    open: false,
    content: {
      mode: "",
      values: null,
    },
  },
  requestGetParams: {},
  pagination: {
    page: 1,
    rowsPerPage: 15,
    totalPages: 0,
    totalItems: 0,
  },
};

const barrarEntregaSlice = createSlice({
  name: "transportadorasApp/barrarEntrega",
  initialState,
  reducers: {
    openDialogForm: (state, action) => {
      state.dialogForm = {
        open: true,
        content: action.payload,
      };
    },
    closeDialogForm: (state) => {
      state.dialogForm = {
        open: false,
        content: {
          mode: "",
          values: null,
        },
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(Actions.getBarrarEntrega.fulfilled, dataBarrarEntregaReducer);
  },
});

export const { openDialogForm, closeDialogForm } = barrarEntregaSlice.actions;

export default barrarEntregaSlice.reducer;
